module.exports = __webpack_public_path__ + "img/Share of Search.c98573dd.svg";